import { render } from "./Form.vue?vue&type=template&id=1e11e65e&scoped=true&ts=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=1e11e65e&scoped=true&lang=css"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e11e65e"]])

export default __exports__